// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"3efb42d1","21":"f3789ed3","55":"8b614732","137":"40bb427c","184":"2276322f","355":"a8979255","369":"d8c87885","373":"30e258ed","566":"66f83567","577":"39558bc7","808":"4bd55ec1"}[chunkId] + ".chunk.js";
};